import React from 'react';
import PropTypes from 'prop-types';
import { EditorWizardContext } from '../../hoc/EditorWizard';
import Loading from '../Loading';
import CreatCourseLoading from '../Loading/CreateLoading/createLoading';
import styles from './styles.less';

const Wizard = ({ content, children }) => {
  const { loading, hideHeaderBar, step } = React.useContext(EditorWizardContext);
  const ShowLoading = () => {
    if (step === 7) {
      return (
        <CreatCourseLoading
          loadingTitle="Thanks for the wait"
          loadingDescription="Couple of second while we’re creating your page!"
          className={styles.center}
        />
      );
    }
    return <Loading className={styles.center} />;
  };
  return (
    <div className={step > 0 ? styles.flex : styles.flexTerm}>
      <div hidden={hideHeaderBar} className={styles.left}>
        <div className={styles.leftInner}>{content}</div>
        <div className={styles.right}>{loading ? ShowLoading() : children}</div>
      </div>
    </div>
  );
};

Wizard.propTypes = {
  content: PropTypes.element,
  children: PropTypes.element,
};

Wizard.defaultProps = {
  content: null,
  children: null,
};

Wizard.getInitialProps = async () => {};

export default Wizard;
